import { INavData } from '@coreui/angular';

export interface NavItemWithPermission extends INavData {
  permission?: string;
  children?: NavItemWithPermission[];
}

export const allNavItems: NavItemWithPermission[] = [
  // GENERAL
  {
    name: 'Resumen',
    url: '/admin/dashboard',
    iconComponent: { name: 'cil-chart' },
    permission: 'home.dashboard',
  },

  // ADMINISTRACIÓN
  {
    title: true,
    name: 'ADMINISTRACIÓN',
    permission: 'user.index',
  },
  {
    name: 'Clientes',
    url: '/admin/clients',
    iconComponent: { name: 'cil-building' },
    permission: 'client.index',
  },
  {
    name: 'Planes',
    url: '/admin/plans',
    iconComponent: { name: 'cil-credit-card' },
    permission: 'plan.index',
  },
  {
    name: 'Usuarios',
    url: '/admin/users',
    iconComponent: { name: 'cil-user' },
    permission: 'user.index',
  },
  {
    name: 'Roles',
    url: '/admin/roles',
    iconComponent: { name: 'cil-layers' },
    permission: 'role.index',
  },
  /* {
    name: 'Suscripciones',
    url: '/admin/subscriptions',
    iconComponent: { name: 'cilBadge' },
    permission: 'subscription.index',
  }, */
  {
    name: 'Actividad',
    url: '/admin/logs',
    iconComponent: { name: 'cil-speedometer' },
    permission: 'logs.index',
  },
  // Como Registros, observa lo que hacen los usuarios en vez de configurar
  // nada: por eso va aqui y no en Mantenimiento, junto a Generador IA.
  {
    name: 'Uso de IA',
    url: '/admin/ai-usage',
    iconComponent: { name: 'cil-chart-pie' },
    permission: 'ai_usage.index',
  },

  // CAMPAÑAS
  {
    title: true,
    name: 'CAMPAÑAS',
    permission: 'campaign.index',
  },
  {
    name: 'Configuración',
    url: '/admin/settings',
    iconComponent: { name: 'cil-cog' },
    permission: 'configuration.index',
  },
  {
    name: 'Campañas',
    url: '/admin/campaigns',
    iconComponent: { name: 'cil-bullhorn' },
    permission: 'campaign.index',
  },
  {
    name: 'Credenciales',
    url: '/admin/credentials',
    iconComponent: { name: 'cil-address-book' },
    permission: 'record.index',
  },

  // LABORATORIO IA
  /* {
    title: true,
    name: 'LABORATORIO IA',
    permission: 'lab.index',
  },
  {
    name: 'Fondos',
    url: '/admin/lab/background-generator',
    iconComponent: { name: 'cil-drop' },
    permission: 'lab.index',
  },
  {
    name: 'Eslóganes',
    url: '/admin/lab/slogan-generator',
    iconComponent: { name: 'cil-speech' },
    permission: 'lab.index',
  }, */

  // MANTENIMIENTO
  {
    title: true,
    name: 'MANTENIMIENTO',
    permission: 'maintenance.index',
  },
  // Una sola entrada: temáticas, tipos de evento y voces se administran en la
  // misma pantalla, en pestañas. Son tres desplegables del mismo formulario y
  // dos de ellos tienen media docena de filas: una pantalla por cada uno
  // sobraba.
  {
    name: 'Generador IA',
    url: '/admin/maintenance/ia-generator',
    iconComponent: { name: 'cil-puzzle' },
    permission: 'theme.index',
  },
  /* {
    name: 'Diseños',
    url: '/admin/maintenance/designs',
    iconComponent: { name: 'cil-featured-playlist' },
    permission: 'design.index',
  }, */
];
